/*
    Create by fanglijuan 2017-05-25
*/
'use strict';
angular.module("deleteAccountSynchroToGroupModule", [])
    .controller("deleteAccountSynchroToGroupCtrl", ["$scope", "$location", "$stateParams", "$q", "$filter", "$timeout", "$modalInstance", "trsHttpService", 'treeService', "$state", "$validation", "trsspliceString", "globleParamsSet", "accountSynchroToGroupService", "modalDialog", "item",
        function($scope, $location, $stateParams, $q, $filter, $timeout, $modalInstance, trsHttpService, treeService, $state, $validation, trsspliceString, globleParamsSet, accountSynchroToGroupService, modalDialog, item) {
            initStatus();
            initData();

            function initStatus() {
                $scope.status = {
                    synGroupId: item.SYNGROUPID,
                };
                $scope.data = {
                    modalTitle: "组织同步",
                    "navTitle": "删除",
                    currGroup: [],
                    currMLFGroup: [],
                };
            }
            /**
             * [initData description]初始化数据
             */
            function initData() {
                getSynGroupDetail();
            }
            //根据组织ID获取需要同步的组织信息
            function getSynGroupDetail() {
                var params = {
                    "serviceid": "mlf_groupmanagement",
                    "methodname": "getSynGroupDetail",
                    "SynGroupId": $scope.status.synGroupId
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.currGroup = data;
                });
            }
            //删除：点击确定
            $scope.confirm = function() {
                var params = {
                    "serviceid": "mlf_groupmanagement",
                    "methodname": "deleteSynGroup",
                    "SynGroupId": $scope.status.synGroupId,
                    "DepartId": $scope.data.currGroup.DEPARTID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    /*modalDialog.alertType('同步成功', "", "success", false, function() {
                        $modalInstance.close(data);
                    });*/
                    var res = data.ISSUCCESS == 'true' ? 'success' : 'error';
                    modalDialog.alertType(data.REPORTS[0].DETAIL, "", res, false, function() {
                        $modalInstance.close();
                    });
                });
            };
            //取消
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);
